import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { encodeDimFilters, decodeDimFilters } from './urlCodecs'

export function useFilterDimsState(): [
  Record<string, string[]>,
  (next: Record<string, string[]>, opts?: { replace?: boolean }) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams()

  const value = useMemo(() => {
    const flat: Record<string, string> = {}
    for (const [k, v] of searchParams.entries()) flat[k] = v
    return decodeDimFilters(flat)
  }, [searchParams])

  const setter = useCallback(
    (next: Record<string, string[]>, opts?: { replace?: boolean }) => {
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev)
          for (const key of [...params.keys()]) {
            if (key.startsWith('dim.')) params.delete(key)
          }
          const encoded = encodeDimFilters(next)
          for (const [k, v] of Object.entries(encoded)) params.set(k, v)
          return params
        },
        // Effect-writers (dim defaults, Model default) pass replace — no phantom Back steps.
        { replace: opts?.replace ?? false },
      )
    },
    [setSearchParams],
  )

  return [value, setter]
}
